import { useLocation } from "react-router-dom";
import queryString from "query-string";

export function useQueryParams() {
  const location = useLocation();
  return queryString.parse(location.search);
}
